import React, { Component } from 'react'
/*import GoogleMapsStyles from './GoogleMapsStyles.json'
// import MarkerImage from './poi.svg'
import MarkerImage from './levain_pin.png'*/
import './Map.css'

/*import MarkerFarang from './farang.png'
import MarkerGaijin from './gaijin.png'
import MarkerBoulevardSocial from './boulevard-social.png'
import MarkerBronda from './bronda.png'
import MarkerLevain from './levain.png'*/

class Map extends Component {
 /* componentDidMount() {
    const latLng1 = {lat: 60.159273, lng: 24.934880}
    const latLng2 = {lat: 60.172973, lng: 24.921188}

    const FarangPosition = {lat: 60.171952, lng: 24.931447}
    const GaijinPosition = {lat: 60.165974, lng: 24.942055}
    const BoulevardSocialPosition = GaijinPosition
    const BrondaPosition = {lat: 60.167011, lng: 24.945389}
    const LevainPunavuoriPosition = {lat: 60.159273, lng: 24.936880}
    const LevainTooloPosition = {lat: 60.172973, lng: 24.923188}

    const mapPunavuori = new window.google.maps.Map(this.refs.mapPunavuori, {
      zoom: 17,
      minZoom: 13,
      maxZoom: 18,
      center: latLng1,
      mapTypeId: 'roadmap',
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: false,
      styles: GoogleMapsStyles
    });

    const mapToolo = new window.google.maps.Map(this.refs.mapToolo, {
      zoom: 17,
      minZoom: 13,
      maxZoom: 18,
      center: latLng2,
      mapTypeId: 'roadmap',
      mapTypeControl: false,
      streetViewControl: false,
      scrollwheel: false,
      styles: GoogleMapsStyles
    });

    const Marker = {
      url: MarkerImage,
      size: new window.google.maps.Size(52,75),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,75)
    };

    const Farang = {
      url: MarkerFarang,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    const Gaijin = {
      url: MarkerGaijin,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    const BoulevardSocial = {
      url: MarkerBoulevardSocial,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    const Bronda = {
      url: MarkerBronda,
      size: new window.google.maps.Size(52,52),
      origin: new window.google.maps.Point(0,0),
      anchor: new window.google.maps.Point(21,21)
    };

    // const Levain = {
    //   url: Marker,
    //   size: new window.google.maps.Size(52,52),
    //   origin: new window.google.maps.Point(0,0),
    //   anchor: new window.google.maps.Point(21,21)
    // };

    new window.google.maps.Marker({
      position: LevainPunavuoriPosition,
      map: mapPunavuori,
      icon: Marker
    });

    new window.google.maps.Marker({
      position: LevainTooloPosition,
      map: mapPunavuori,
      icon: MarkerLevain
    });

    new window.google.maps.Marker({
      position: LevainPunavuoriPosition,
      map: mapToolo,
      icon: MarkerLevain
    });

    new window.google.maps.Marker({
      position: LevainTooloPosition,
      map: mapToolo,
      icon: Marker
    });

    new window.google.maps.Marker({
      position: FarangPosition,
      map: mapPunavuori,
      icon: Farang
    });

    new window.google.maps.Marker({
      position: FarangPosition,
      map: mapToolo,
      icon: Farang
    });

    new window.google.maps.Marker({
      position: GaijinPosition,
      map: mapPunavuori,
      icon: Gaijin
    });

    new window.google.maps.Marker({
      position: GaijinPosition,
      map: mapToolo,
      icon: Gaijin
    });

    new window.google.maps.Marker({
      position: BoulevardSocialPosition,
      map: mapPunavuori,
      icon: BoulevardSocial
    });

    new window.google.maps.Marker({
      position: BoulevardSocialPosition,
      map: mapToolo,
      icon: BoulevardSocial
    });

    new window.google.maps.Marker({
      position: BrondaPosition,
      map: mapPunavuori,
      icon: Bronda
    });

    new window.google.maps.Marker({
      position: BrondaPosition,
      map: mapToolo,
      icon: Bronda
    });

    // const centerPunavuori = mapPunavuori.getCenter();
    // const centerToolo = mapToolo.getCenter();

    // window.google.maps.event.addListenerOnce(mapPunavuori, 'idle', function() {
    //   window.google.maps.event.trigger(mapPunavuori, 'resize');
    //   mapPunavuori.setCenter(centerPunavuori);
    // })
    // window.google.maps.event.addDomListener(window, 'resize', function() {
    //   mapPunavuori.setCenter(centerPunavuori);
    // })

    // window.google.maps.event.addListenerOnce(mapToolo, 'idle', function() {
    //   window.google.maps.event.trigger(mapToolo, 'resize');
    //   mapToolo.setCenter(centerToolo);
    // })
    // window.google.maps.event.addDomListener(window, 'resize', function() {
    //   mapToolo.setCenter(centerToolo);
    // })
  }
*/
  render() {
    return (
      <div className="map-wrapper">
        <div className="google-map punavuori" ref="mapPunavuori">
        <div className="map-contributors"><div><a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> | © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> © <a href="http://cartodb.com/attributions">CartoDB</a></div></div>
        </div>
        <div className="google-map toolo" ref="mapToolo">
        <div className="map-contributors"><div><a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> | © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> © <a href="http://cartodb.com/attributions">CartoDB</a></div></div>
        </div>
        <div className="google-map ullanlinna" ref="mapUllanlinna">
        <div className="map-contributors"><div><a href="http://leafletjs.com" title="A JS library for interactive maps">Leaflet</a> | © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> © <a href="http://cartodb.com/attributions">CartoDB</a></div></div>
        </div>
      </div>
    )
  }
}

export default Map;



// WEBPACK FOOTER //
// ./src/components/Map/Map.js